import React from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import { MdOutlineAttachMoney } from "react-icons/md";
import { FaHistory } from "react-icons/fa";

import './layout.css';

const PFlayout = ({ children }) => {
  const location = useLocation();

  return (
    <div className='container-fluid'>
    <div style={{marginTop:'10px'}}>
      <section>
        <div className="nav-container">
          <ul className="nav-list">
            <li className="nav-item">
              <NavLink
                id="provident-fund-link"
                className={({ isActive }) => `nav-link ${isActive || location.pathname === '/provident-fund' ? 'active' : ''}`}
                to="/provident-fund"
              >
                <MdOutlineAttachMoney className="nav-icon" /> Provident Fund
              </NavLink>
            </li>
            <li className="nav-item">
              <NavLink
                id="provident-fund-history-link"
                className={({ isActive }) => `nav-link ${isActive || location.pathname === '/provident-fund-history' ? 'active' : ''}`}
                to="/provident-fund-history"
              >
                <FaHistory className="nav-icon" /> Provident Fund History
              </NavLink>
            </li>
          </ul>
        </div>
        <div className="content">
          {children}
        </div>
      </section>
    </div>
    </div>
  );
};

export default PFlayout;
